var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityData, component } from "./entity.data";
import { LocalisableContextData } from "./localisable-context.data";
/**
 * Defines a localisable entity data
 */
export class LocalisableEntityData extends EntityData {
    constructor() {
        super(...arguments);
        this.localisableContext = EntityData.create(LocalisableContextData);
        this.localisableChildContext = EntityData.create(LocalisableContextData);
    }
    /**
     * Is the specified field currently restricted given the localisation context of this localisable entity?
     * @return {boolean}
     * @param path
     */
    isRestricted(path) {
        return this.localisableContext.restricted && !this.isUnrestricted(path);
    }
}
__decorate([
    component,
    __metadata("design:type", LocalisableContextData)
], LocalisableEntityData.prototype, "localisableContext", void 0);
__decorate([
    component,
    __metadata("design:type", LocalisableContextData)
], LocalisableEntityData.prototype, "localisableChildContext", void 0);
//# sourceMappingURL=localisable-entity.data.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/entity/localisable-entity.data.js
// module id = 220
// module chunks = 1